<template>
	<button type="button" class="flex order-1 items-center" tabindex="0"
		:title="rating + '/' + 5"
		v-b-popover.focus.bottom="'This score is calculated for this specific partner using a weighted average based on consumer concerns received by TrustDALE.'">
		<span class="hidden">
			<span>{{ buttonText }}</span>
		</span>
		<div ref="starContainer"></div>
		<div class="ml-[7px]">
			<i class="fas fa-caret-down"></i>
		</div>
	</button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Rater from 'rater-js';

export default defineComponent({
	name: "StarRating",
	props: {
		buttonText: {
			type: String,
			default: 'rating'
		},
		rating: {
			type: [Number, String],
			default: 4.8,
		},
		size: {
			type: Number,
			default: 22,
		}
	},
	mounted() {
		const rater = Rater({
			element: this.$refs.starContainer as HTMLElement,
			starSize: this.size,
			readOnly: true
		});

		rater.setRating(this.rating);
	},
});
</script>

<style>
.star-rating {
    background: url('/storage/icons/star_off.svg') contain !important;
}
.star-rating .star-value {
    background: url('/storage/icons/star_on.svg') contain !important;
}
</style>
